exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-asset-dialog[data-v-47ce35ba]{\n  height:600px;\n  overflow:hidden\n}", ""]);

// exports
